import React, { Component } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { DateTimeHelper } from '../../../dateTimeHelper';
import "./CardCarousel.scss";


function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, backgroundColor: "#fcfcf1", borderRadius: "40px" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, backgroundColor: "#fcfcf1", borderRadius: "40px" }}
      onClick={onClick}
    />
  );
}
export default class CardCarousel extends Component {
  constructor() {
    super();
    this.state = {
      data: {},
      feed: []
    }
  }
  async componentDidMount() {
    const url = "https://api.rss2json.com/v1/api.json?rss_url=https%3A%2F%2Fmedium.com%2Ffeed%2F%40tapendradev";
    const response = await fetch(url);
    const data = await response.json();
    this.setState({ data: data, feed: data.items });
  }

  render() {
    const settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />
    };

    return (
      <div className="container-fluid">
        <Slider {...settings}>
          {this.state.feed.map((indiData, key) => {
            return <div className="card-grid-space" key={key}>
              <a className="card" href={indiData.link} style={{ backgroundImage: `url(${indiData.thumbnail ? indiData.thumbnail : "https://images1-focus-opensocial.googleusercontent.com/gadgets/proxy?container=focus&resize_w=1500&url=https://codetheweb.blog/assets/img/posts/html-syntax/cover.jpg"})` }}>
                <div>
                  <h1>{indiData.title ? indiData.title : null}</h1>
                  {/* <p>{indiData.description}</p> */}
                  <div className="date">{DateTimeHelper.formatDateTime(indiData.pubDate) || null}</div>
                  <div className="tags">
                    <div className="tag">{indiData.categories[0] ? indiData.categories[0] : null}</div>
                    <div className="tag">{indiData.categories[1] ? indiData.categories[1] : null}</div>
                  </div>
                </div>
              </a>
            </div>
          })}
        </Slider>
      </div>
    );
  }
}
